import { useDisclosure } from '@hooks/useDisclosure';
import { EditOutlined } from '@mui/icons-material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useGreenhouseForm } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider';
import { IOtherDetailFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import ModalOtherGreenhouseGas from '../ModalOtherGreenhouseGas/ModalOtherGreenhouseGas';

type OtherGreenhouseEditButtonProp = { rowId: number | string };

const OtherGreenhouseEditButton = ({
  rowId,
}: OtherGreenhouseEditButtonProp) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, watch } = useGreenhouseForm();
  const isNewDetails = typeof rowId === 'string';
  const completedSection = watch('greenhouseGoalTerm.completedSection');
  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  const handleEditOtherGreenhouse = () => {
    open();
  };

  const otherDetails =
    getValues('greenhouseGoalTerm.other.details') ??
    ([] as Array<IOtherDetailFormValues>);

  const currentDetails = opened
    ? otherDetails.find((detail, index) => {
        if (isNewDetails)
          return index === Number(rowId.replace('NEW-', '')) - 1;
        return detail.id === rowId;
      })
    : undefined;

  const currentIndex = isNewDetails
    ? Number(rowId.replace('NEW-', '')) - 1
    : otherDetails.findIndex((detail) => detail.id === rowId);

  return (
    <>
      <GridActionsCellItem
        key="edit"
        icon={<EditOutlined style={{ fontSize: '16px' }} />}
        onClick={handleEditOtherGreenhouse}
        label="Edit"
        disabled={isCompletedTh && isCompletedEn}
      />
      {opened && (
        <ModalOtherGreenhouseGas
          mode="edit"
          open={opened}
          close={close}
          editData={currentDetails}
          editIndex={currentIndex}
        />
      )}
    </>
  );
};

export default OtherGreenhouseEditButton;
